export class SkechersPoItemVariant {

    lineNo:string;
    exFactoryDate:string;
    deliveryDate:string;
    itemType:string;
    color: string;
    size: string;
    quantity:string;
}